// extracted by mini-css-extract-plugin
export default {"cls1":"X9aEyv4JQAggjEiGWyoR","cls2":"xTjashkLfvgPngw_SQlB X9aEyv4JQAggjEiGWyoR"};